/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForZabbix extends models.ServiceAccountCredentialsForBasicAuth {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForZabbix");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForZabbix.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForZabbix>): ServiceAccountCredentialsForZabbix {
        let obj = Object.assign(new ServiceAccountCredentialsForZabbix(), model);
        ServiceAccountCredentialsForZabbix.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForZabbix>): ServiceAccountCredentialsForZabbix {
        if (!model) return null;
        return ServiceAccountCredentialsForZabbix.newInstance(<ServiceAccountCredentialsForZabbix> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForZabbix) {
        if (!obj) return;

        models.ServiceAccountCredentialsForZabbix.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForZabbix): boolean {
        if (models.ServiceAccountCredentialsForBasicAuth.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForZabbix.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
